import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "social-media screen-start section section--mini" }
const _hoisted_2 = {
  href: "",
  class: "social-media__item social-media-item card"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "social-media-item__icon social-media-item__icon--youtube" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "social-media-item__name" }, "YouTube channels", -1)
const _hoisted_5 = { class: "social-media-item__arrow" }
const _hoisted_6 = {
  href: "",
  class: "social-media__item social-media-item card"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "social-media-item__icon social-media-item__icon--youtube" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "social-media-item__name" }, "YouTube channels", -1)
const _hoisted_9 = { class: "social-media-item__arrow" }
const _hoisted_10 = {
  href: "",
  class: "social-media__item social-media-item card"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "social-media-item__icon social-media-item__icon--youtube" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "social-media-item__name" }, "YouTube channels", -1)
const _hoisted_13 = { class: "social-media-item__arrow" }

import "./SocialMediaView.scss";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import Icon from "@/components/Icon/Icon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SocialMediaView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdditionalLayout, { title: "Social Media" }, {
    default: _withCtx(() => [
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("a", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("i", _hoisted_5, [
            _createVNode(Icon, { name: "up" })
          ])
        ]),
        _createElementVNode("a", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("i", _hoisted_9, [
            _createVNode(Icon, { name: "up" })
          ])
        ]),
        _createElementVNode("a", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("i", _hoisted_13, [
            _createVNode(Icon, { name: "up" })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})